import { useSelector } from 'react-redux'

import { selectUserConfiguration } from '@/features/domain/user'

export function useIsSimulation() {
  const { planType } = useSelector(selectUserConfiguration)
  return planType === 'simulation'
}
